import { Switch } from '@mui/material';
import { Field } from 'formik';
import React from 'react'
import MuiLabel from './MuiLabel';

export const MuiSwitch = (props) => {
  const {name,label, ...rest} = props;
  return (
    <Field name={name} {...rest}>
        {
            ({field})=>{
              const {value} = field
                return(
                    <React.Fragment>
                      <MuiLabel {...props} />
                         <Switch 
                         {...rest}
                         {...field}
                         checked={value}
                         />
                    </React.Fragment>
                )
            }
        }

    </Field>
  )
}
